import { supabase } from '../lib/supabase';

// Authorization header for backend calls that gate on identity (the brand
// API since r89). The backend VERIFIES this JWT server-side — unlike the
// user_id param, it cannot be spoofed. Lives in its own module because
// lib/supabase.js imports utils/api.js (adding it there would be a cycle).
export async function authHeaders() {
  try {
    const { data } = await supabase.auth.getSession();
    const token = data?.session?.access_token;
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
}
